import { images } from "../constants";

const testimonials = [  
    { 
        id: 1,
        image: images.testimonial1, 
        name: 'David Anderson', 
        title: 'Business Traveler',
        content: 'The car rental service was outstanding! The vehicle was in perfect condition, and the booking process was smooth. I highly recommend them!'
    }, 
    { 
        id: 2,
        image: images.testimonial2, 
        name: 'Sophia Miller', 
        title: 'Tourist',
        content: 'Amazing service! I rented a car for my road trip, and everything went smoothly. The staff was friendly, and the prices were great. Will rent again!'
    },
    { 
        id: 3,
        image: images.testimonial3, 
        name: 'Mark Robinson', 
        title: 'Frequent Renter',
        content: 'I\'ve used their car rental services multiple times, and they never disappoint. The cars are always clean, reliable, and well-maintained.'
    },    
    { 
        id: 4,
        image: images.testimonial4, 
        name: 'Emma Williams', 
        title: 'Local Resident',
        content: 'Fantastic customer service and a great selection of cars. The rental process was quick and easy. Highly recommended for anyone.'
    },
];

export default testimonials;